import { useFeatureValue } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

import { useIsPrescriberFlow } from './prescriber-flow';

interface InSessionClinicalGoalsFlag {
  [key: string]: boolean;
  show_warning: boolean;
  show_tab: boolean;
}

const DEFAULT_VALUE: InSessionClinicalGoalsFlag = {
  show_warning: true,
  show_tab: true,
};

const HIDDEN_VALUE: InSessionClinicalGoalsFlag = {
  show_warning: false,
  show_tab: false,
};

export const useInSessionClinicalGoals = (): InSessionClinicalGoalsFlag => {
  const isPrescriberFlow = useIsPrescriberFlow();

  if (isPrescriberFlow) {
    return HIDDEN_VALUE;
  }

  return useFeatureValue<InSessionClinicalGoalsFlag>(
    GROWTHBOOK_FEATURE_FLAGS.IN_SESSION_CLINICAL_GOALS,
    DEFAULT_VALUE,
  );
};
